"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getAdPlacementPayload = getAdPlacementPayload;
var _lowerCase2 = _interopRequireDefault(require("lodash/lowerCase"));
var _format = _interopRequireDefault(require("date-fns/format"));
function getAdPlacementPayload(_ref) {
  var _searchRequest$pax, _searchRequest$pax2, _$resources$getAirpor, _$resources$getAirpor2, _$resources$getAirpor3, _$resources$getAirpor4, _config$posConfig, _config$posConfig$con;
  var searchRequest = _ref.searchRequest,
    config = _ref.config,
    $resources = _ref.$resources;
  var pax = (searchRequest === null || searchRequest === void 0 ? void 0 : (_searchRequest$pax = searchRequest.pax) === null || _searchRequest$pax === void 0 ? void 0 : _searchRequest$pax.adult) + (searchRequest === null || searchRequest === void 0 ? void 0 : (_searchRequest$pax2 = searchRequest.pax) === null || _searchRequest$pax2 === void 0 ? void 0 : _searchRequest$pax2.child);
  var tripType = {
    oneway: 'oneway',
    roundtrip: 'return',
    multicity: 'multi'
  };
  var originCountry = (_$resources$getAirpor = $resources.getAirport(searchRequest.originId, true)) === null || _$resources$getAirpor === void 0 ? void 0 : (_$resources$getAirpor2 = _$resources$getAirpor.country) === null || _$resources$getAirpor2 === void 0 ? void 0 : _$resources$getAirpor2.code;
  var destinationCountry = (_$resources$getAirpor3 = $resources.getAirport(searchRequest.destinationId, true)) === null || _$resources$getAirpor3 === void 0 ? void 0 : (_$resources$getAirpor4 = _$resources$getAirpor3.country) === null || _$resources$getAirpor4 === void 0 ? void 0 : _$resources$getAirpor4.code;
  var payload = {
    pos: (_config$posConfig = config.posConfig) === null || _config$posConfig === void 0 ? void 0 : (_config$posConfig$con = _config$posConfig[config === null || config === void 0 ? void 0 : config.countryCode]) === null || _config$posConfig$con === void 0 ? void 0 : _config$posConfig$con.code,
    language: config.language,
    arrival_date: (0, _format.default)(searchRequest.departureDate, 'MM/DD/YYYY'),
    return_date: searchRequest.returnDate ? (0, _format.default)(searchRequest.returnDate, 'MM/DD/YYYY') : undefined,
    cabin_class: (0, _lowerCase2.default)(searchRequest.preferredCabin),
    pax_count: pax.toString(),
    origin_airport: searchRequest.originId,
    destination_airport: searchRequest.destinationId,
    origin_country_code: originCountry,
    destination_country_code: destinationCountry,
    platform: config.isMobile ? 'mweb' : 'desktop',
    trip_type: tripType[searchRequest.searchType]
  };
  return {
    zoneIDs: config.isLive ? [893061] : [864351],
    dataKeys: payload
  };
}